const PAYMENT_ERROR_MESSAGES = {
  406: "Action failed",
  407: "Action failed",
  421: "Card number is not valid.",
  422: "Expired date is not valid.",
  429: "Zip code is not valid.",
  430: "AVS Postal Code does not match",
  431: "AVS Postal Code not verified",
  432: "CVV is not valid.",
  433: "CVV does not match",
  434: "CVV is not verified",
  435: "CVV issuer does not participate",
  436: "Your card was declined",
  437: "An error occurred while processing your card. Try again in a little bit.",
  439: "CVV not processed",
  441: "No CVV data from issuer",
  443: "No data from issuer/banknet switch",
  445: "AVS System unable to process",
  446: "Issuing bank does not support AVS",
  447: "AVS not supported for your business",
  448: "This card has been blocked due to repeated unsuccessful payment attempts. Please change your payment method or try again later",
  452: "Your card is declined. Please enter another credit card that was registered at the same area as your phone number",
  454: "AVS Address does not match",
  455: "AVS Both postal code and address do not match",
  458: "Authentication failed",
  459: "Bank cards are not supported",
  461: "This card is not supported",
  462: "Card holder name is invalid",
  463: "Verification code is invalid",
  464: "The bank does not support generating and sending the verification code",
  470: "Email is required",
  474: "Name is required",
  475: "Phone number is required",
  476: "Amount is invalid",
  911: "We are unable to authenticate your payment method. Please choose a different payment method and try again.",
  "-1": "This customer account has been deactivated. Please contact our administrator.",
};

export const getPaymentErrorMessage = (data, fallbackMessage) => {
  const returnCode =
    data?.returnCode ?? data?.response?.returnCode ?? data?.error?.errorCode;

  return (
    PAYMENT_ERROR_MESSAGES[String(returnCode)] ??
    data?.message ??
    data?.responseMessage ??
    fallbackMessage
  );
};

export default PAYMENT_ERROR_MESSAGES;
